import routerOptions0 from "D:/.jenkins/workspace/web-prod-xkira-official-website/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@_0a82593bfa7fb480d583bd8758123f00/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}